import { Plans } from "./Plans";
import ToolboxOverview from "./ToolboxOverview";
import ToolboxProfilePage from "./ToolboxProfilePage";
import ToolboxResponsesPage from "./ToolboxResponsesPage";

const CheckIns = () => <p>Toolbox Check-Ins</p>;
const CheckInsNew = () => <p>Toolbox Check-Ins New</p>;
const CheckInsEdit = () => <p>Toolbox Check-Ins Edit</p>;

export const ToolboxPage = {
  Overview: ToolboxOverview,
  Profile: ToolboxProfilePage,
  Responses: ToolboxResponsesPage,
  Plans,
  CheckIns,
  CheckInsNew,
  CheckInsEdit,
};
